// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieSettings_container__iPgm_"};